import useCustomFuncCtx from '@/composables/custom-func/custom-func-ctx';
import { customFunc } from 'shared/constants.json';
import { ref } from 'vue';

const KEY_TYPE_DATE = 'date';
const KEY_TYPE_STRING = 'string';
const KEY_TYPE_NUMBER = 'number';

const STRUCTURE_ARRAY = 'array';
const STRUCTURE_OBJECT = 'object';
const STRUCTURE_SCALAR = 'scalar';

const customFuncKeyMap = {
  [customFunc.progressCourse]: { key: 'date', type: KEY_TYPE_DATE, structure: STRUCTURE_ARRAY },
  [customFunc.progressCourseList]: { key: 'date', type: KEY_TYPE_DATE, structure: STRUCTURE_ARRAY },
  [customFunc.goalInsights]: { key: 'date', type: KEY_TYPE_DATE, structure: STRUCTURE_ARRAY },
  [customFunc.updateParticipationList]: { key: 'time', type: KEY_TYPE_DATE, structure: STRUCTURE_ARRAY },
};

const normalizeValue = (value, type) => {
  switch (type) {
    case KEY_TYPE_DATE:
      return new Date(value).getTime();
    case KEY_TYPE_NUMBER:
      return Number(value);
    case KEY_TYPE_STRING:
    default:
      return String(value);
  }
};

export default function useCustomFunc() {
  const customFuncCtxAlias = ref(null);
  const customFuncCtx = useCustomFuncCtx(customFuncCtxAlias);

  const hasAllEntriesForEntity = (entity, customFuncName, customFuncAlias, customFuncArgs) => {
    if (customFuncAlias === undefined || customFuncArgs.length === 0) {
      return true;
    }

    customFuncCtxAlias.value = customFuncAlias;

    const customFuncState = customFuncCtx.state.value;

    if (customFuncState === undefined) {
      return false;
    }

    const entityData = customFuncState[entity.uid];
    if (entityData === undefined || entityData === null) {
      return false;
    }

    const keyConfig = customFuncKeyMap[customFuncName];
    if (!keyConfig) {
      throw new Error(`Key config not found for custom function name: ${customFuncName}`);
    }

    const { key, type, structure } = keyConfig;
    if ([STRUCTURE_OBJECT, STRUCTURE_SCALAR].includes(structure)) {
      return entityData !== undefined && entityData !== null;
    }

    const dataKeys = new Set(
      entityData.map((entry) => normalizeValue(entry[key], type)),
    );

    return customFuncArgs
      .map((arg) => normalizeValue(arg.value, type))
      .every((normalizedValue) => dataKeys.has(normalizedValue));
  };

  return { hasAllEntriesForEntity };
}
